import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import {
    Grid,
    ListItem,
    QualityControlConcreteResult,
    QualityControlConcreteResultSpecimen,
    RepositoryModal,
} from '../../../shared'
import { ConcreteResultComponent } from './concrete-result.component'

@Component({
    templateUrl: './concrete-result-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, WjGridModule],
})
export class ConcreteResultModalComponent extends RepositoryModal<QualityControlConcreteResult> implements OnInit, OnDestroy {
    concreteVendorOptions: ListItem<number | null>[] = []
    reportSourceOptions: ListItem<string>[] = [
        new ListItem('Test Report', 'Test Report'),
        new ListItem('Daily Report', 'Daily Report'),
    ]
    specimenGrid: Grid<QualityControlConcreteResultSpecimen>

    constructor() {
        super()
        this.specimenGrid = new Grid<QualityControlConcreteResultSpecimen>(this.services).isReadOnly(false).wrapColumnHeaders()
    }

    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as ConcreteResultComponent

        this.concreteVendorOptions = []
        this.concreteVendorOptions.push(new ListItem<number | null>(null, 'Select a Supplier'))
        parentComponent.concreteVendors.forEach(x => {
            this.concreteVendorOptions.push(new ListItem<number | null>(x.id, x.name))
        })

        if (this.isAdding) {
            this.target.job = parentComponent.selectedJob()
            this.target.specimens = []
        } else if (!this.target.specimens) {
            this.target.specimens = []
        }

        this.specimenGrid.items = this.target.specimens
    }

    ngOnDestroy(): void {
        this.specimenGrid.destroy()
    }

    addSpecimen() {
        const specimen = new QualityControlConcreteResultSpecimen()
        specimen.id = '00000000-0000-0000-0000-000000000000'
        specimen.sortOrder = this.specimenGrid.items.length
        this.specimenGrid.items.push(specimen)
        this.specimenGrid.refresh()
    }

    deleteSpecimen() {
        const selected = this.specimenGrid.selectedItem
        if (!selected) {
            this.services.notification.warning('Select a specimen row to delete')
            return
        }
        const index = this.specimenGrid.items.indexOf(selected)
        if (index >= 0) {
            this.specimenGrid.items.splice(index, 1)
            this.specimenGrid.refresh()
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) {
            this.services.notification.warning('Job is required')
            return false
        }

        this.target.specimens = this.specimenGrid.items.map((specimen, index) => ({
            ...specimen,
            sortOrder: index,
        }))

        return true
    }
}
